export function showChatWidget() {
  // @ts-ignore
  window.Tawk_API.showWidget();
}
